const cardSlider = document.querySelectorAll('[data-slider="card-slider"]');

const cardSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  speed: 800,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

cardSlider.forEach((el) => {
  const parentElem = el.closest('.card-list');
  const arrowRight = parentElem.querySelector('.arrow-right');
  const arrowLeft = parentElem.querySelector('.arrow-left');
  cardSliderOptions.navigation.nextEl = arrowRight;
  cardSliderOptions.navigation.prevEl = arrowLeft;
  new Swiper(el, cardSliderOptions);
});

// *******************************************************************************
// CARD LIST
// *******************************************************************************
const cardList = document.querySelector('.card-list');
const cardListFilter = document.querySelector('.card-list__filter-nav');
const cardListSort = document.querySelector('.card-list__filter-inner .dropdown');

if (cardListFilter && cardListSort) {
  // Axios get Publication list
  const axiosGetPaginatedCardList = async (pageNumber = 1) => {
    const checkedSort = cardListSort.querySelector('.dropdown__list-item [type="radio"]:checked')?.id.split('-');
    const formDataInput = {
      action: 'getPaginatedCardList',
      pageNumber,
      tagSlug: (cardListFilter.querySelector('.card-list__filter-link.is-active')?.dataset.slug || '').replace(
        'all',
        '',
      ),
      category: cardList.dataset.category || '0',
      variation: cardList.dataset.variation || 'list_4_images',
      orderBy: checkedSort[0] || 'date',
      order: checkedSort[1] || 'desc',
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      const cardListInner = cardList.querySelector('.card-list__list');
      const cardListPagination = cardList.querySelector('.card-list__pagination');

      if (cardListInner) {
        cardListInner.innerHTML = data.data.html_list;
      }

      if (cardListPagination) {
        cardListPagination.innerHTML = data.data.html_pagination;
      }

      cardList.scrollIntoView();

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['pageNumber', 'tagSlug', 'orderBy', 'order']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
    } catch (err) {
      console.error(err);
    }
  };

  // Filter
  const filterItems = cardListFilter.querySelectorAll('.card-list__filter-link');
  filterItems.forEach((el) => {
    el.addEventListener('click', (ev) => {
      ev.preventDefault();
      filterItems.forEach((item) => item.classList.remove('is-active'));
      el.classList.add('is-active');
      axiosGetPaginatedCardList();
    });
  });

  // Sort
  const sortItems = cardListSort.querySelectorAll('.dropdown__list-item [type="radio"]');
  sortItems.forEach((el) => {
    el.addEventListener('click', () => {
      axiosGetPaginatedCardList();
    });
  });

  // Pagination
  attachEvent('.card-list .pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    axiosGetPaginatedCardList(ev.target.dataset.page);
  });
}
